// extracted by mini-css-extract-plugin
export var highlightFade = "_3c-4";
export var highlighted = "_3c-3";
export var table = "_3c-1";
export var tableContainer = "_3c-0";
export var totalsRow = "_3c-2";